<div class="confirm-width border_5">
    <mat-toolbar class="toolBar">
        <div class="title_div">
            <h2 class="title_text">{{title}}</h2>

            <img *ngIf="!dismissDialog" class="close_icon" src="../../../../../../assets/images/close.svg" alt="close"
                (click)="closeDialog(false)">
            <img *ngIf="dismissDialog"  class="close_icon" src="../../../../../../assets/images/close.svg" alt="close"
                (click)="onDismissDialog('dismiss')">    
        </div>
    </mat-toolbar>
    <mat-dialog-content style="padding: 0 !important;">
        <div class="md-dialog-content user-role-dialog-content dialogContent" >

            <span  class="content_text" [innerHTML]="message"></span>
        </div>
    </mat-dialog-content>


    <mat-dialog-actions *ngIf="!isCancelNo && !isConfirmCancel && !isOk && !isNoYes && !fromSharingItems && !isClose" align="end" class="btn_align">

        <button class="sec-button mr_15"  (click)="onNoClick()">NO</button>
        <button class="prim-button height_28" (click)="onYesClick()">YES, CONTINUE</button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="!isCancelNo && !isConfirmCancel && !isOk && !isNoYes && fromSharingItems && !isClose" align="end" class="btn_align">

        <button class="sec-button-2 mr_15"  (click)="onNoClick()">NO</button>
        <button class="prim-button-2 height_28"  (click)="onYesClick()">YES, CONTINUE</button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="isCancelNo && !isConfirmCancel && !isOk && !isNoYes" align="end" class="btn_align">
        <button class="cancelNo" (click)="onNoClick()">Cancel</button>
        <button class="cancelNo ml_10"  (click)="onYesClick()">Ok</button>
    </mat-dialog-actions>


    <mat-dialog-actions *ngIf="isConfirmCancel && !isOk && !isNoYes" align="end" class="btn_align">
        <button class="cancelNo" (click)="onYesClick()">Confirm</button>
        <button class="cancelNo ml_10" (click)="onNoClick()">Cancel</button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="isOk" align="end" class="btn_align">
        <button class="cancelNo" (click)="onYesClick()">Ok</button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="isClose" align="end" class="btn_align">
        <button class="cancelNo" (click)="onYesClick()">Close</button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="isNoYes" align="end" class="btn_align">

        <button class="sec-button mr_15"  (click)="onNoClick()">NO</button>
        <button class="prim-button height_28"  (click)="onYesClick()">YES</button>
    </mat-dialog-actions>
</div>

